<div class="current-timedate"><span>{{ title }}</span></div>